module.exports = __webpack_public_path__ + "img/footer_partner.7dc2dfc9.jpg";